import React, { FC } from 'react'
import { useSelectOptions } from 'transfix-form/hooks'
import { ISelectProps } from 'transfix-ui/components/Select'
import { COUNTRIES } from 'constants/countriesStates'
import ControlledSelect, { IControlledSelectProps } from '../ControlledSelect'

export interface IControlledCountrySelectProps extends IControlledSelectProps {
  SelectProps?: Partial<Omit<ISelectProps, 'options' | 'value' | 'onChange'>>
  /**
   * Filter out countries that are not needed
   * @default ['US', 'CA']
   */
  includeCountries?: string[]
}

/**
 * Helper component for use with React Hook Form
 * @see https://react-hook-form.com/api#Controller
 * @example
 * ```
 * <ControlledCountrySelect
 *   name='firstName'
 *   control={control}
 * />
 * ```
 */
const ControlledCountrySelect: FC<IControlledCountrySelectProps> = ({
  control,
  defaultValue,
  name,
  onChange,
  SelectProps = {},
  includeCountries = ['US', 'CA'],
}) => {
  const { options = [] } = useSelectOptions({
    options: COUNTRIES.filter(({ code }) => includeCountries.includes(code)),
    mapOption: ({ code: value, name: label }) => ({
      label,
      value,
    }),
  })

  return (
    <ControlledSelect
      name={name}
      control={control}
      defaultValue={defaultValue}
      onChange={onChange}
      SelectProps={{
        label: 'Country',
        options,
        ...SelectProps,
      }}
    />
  )
}

export default ControlledCountrySelect
